//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AccountingEventExportResult, AccountingEventExportScheduleResult, CreateAccountingEventExportInput } from './types';


export interface IAccountingEventClient {

    createExport(input: CreateAccountingEventExportInput): Promise<AccountingEventExportResult>;

    listExports(): Promise<AccountingEventExportResult[]>;

    getExportById(exportId: number): Promise<AccountingEventExportResult>;

    getLastRefreshTime(stream: string | undefined): Promise<string | null>;

    getSchedules(): Promise<AccountingEventExportScheduleResult[]>;
}

export class AccountingEventClient extends PosClientBase implements IAccountingEventClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createExport(input: CreateAccountingEventExportInput, signal?: AbortSignal | undefined): Promise<AccountingEventExportResult> {
        let url_ = this.baseUrl + "/api/AccountingEvent/CreateExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExport(_response);
        });
    }

    protected processCreateExport(response: Response): Promise<AccountingEventExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportResult>(null as any);
    }

    listExports(signal?: AbortSignal | undefined): Promise<AccountingEventExportResult[]> {
        let url_ = this.baseUrl + "/api/AccountingEvent/ListExports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListExports(_response);
        });
    }

    protected processListExports(response: Response): Promise<AccountingEventExportResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportResult[]>(null as any);
    }

    getExportById(exportId: number, signal?: AbortSignal | undefined): Promise<AccountingEventExportResult> {
        let url_ = this.baseUrl + "/api/AccountingEvent/GetExportById/{exportId}";
        if (exportId === undefined || exportId === null)
            throw new Error("The parameter 'exportId' must be defined.");
        url_ = url_.replace("{exportId}", encodeURIComponent("" + exportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExportById(_response);
        });
    }

    protected processGetExportById(response: Response): Promise<AccountingEventExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportResult>(null as any);
    }

    getLastRefreshTime(stream: string | undefined, signal?: AbortSignal | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/AccountingEvent/GetLastRefreshTime?";
        if (stream === null)
            throw new Error("The parameter 'stream' cannot be null.");
        else if (stream !== undefined)
            url_ += "stream=" + encodeURIComponent("" + stream) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastRefreshTime(_response);
        });
    }

    protected processGetLastRefreshTime(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getSchedules(signal?: AbortSignal | undefined): Promise<AccountingEventExportScheduleResult[]> {
        let url_ = this.baseUrl + "/api/AccountingEvent/GetSchedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSchedules(_response);
        });
    }

    protected processGetSchedules(response: Response): Promise<AccountingEventExportScheduleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountingEventExportScheduleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountingEventExportScheduleResult[]>(null as any);
    }
}
